import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { menuClient } from "../services/menuClient";

const name = "menu";
const extraActions = createExtraActions();
const reducers = createReducers();
const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState: { menuList: [], isLoading: false, error: null },
  extraReducers,
  reducers,
});
export const menuReducer = slice.reducer;
export const menuActions = { ...extraActions, ...slice.actions };

function createExtraActions() {
  return {
    get: get(),
  };

  function get() {
    return createAsyncThunk(`${name}/get-all`, () =>
      menuClient.get(`/get-all`)
    );
  }
}

function createReducers() {
  return {
    set,
  };

  function set(state, action) {
    state.menu = action.payload;
  }
}
function createExtraReducers() {
  return (builder) => {
    get();
    function get() {
      var { pending, fulfilled, rejected } = extraActions.get;
      builder.addCase(pending, (state) => {
        state.error = null;
        state.isLoading = true;
      });
      builder.addCase(fulfilled, (state, action) => {
        state.error = false;
        state.menuList = action.payload.data;
        state.isLoading = false;
      });
      builder.addCase(rejected, (state, action) => {
        if (action.error.name === "TypeError") {
          state.error = {
            message:
              "Sistem genelinde bir hata oluştu. Lütfen Sistem Geliştirme Birimine bildiriniz.",
          };
        } else {
          state.error = action.error;
        }

        state.isLoading = false;
        state.isMfa = false;
      });
    }
  };
}
